import useAuth from '#/hooks/useAuth';
import { ROUTE_NAMES } from '#/router/routes';
import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

const ProtectedRoute = () => {
  const { retrieveAuth } = useAuth();

  const navigate = useNavigate();

  useEffect(() => {
    const auth = retrieveAuth();

    if (!auth) {
      navigate(ROUTE_NAMES.LOGIN);
    }
  }, [navigate, retrieveAuth]);

  return <Outlet />;
};

export default ProtectedRoute;
